import { TextInput } from '@adc/parallax-component-library';

import type { CLMSingleLineTextInputProps } from './types';

export const CLMTextInput = ({
  label,
  ariaLabel,
  ...rest
}: CLMSingleLineTextInputProps) => {
  return (
    <TextInput
      aria-label={ariaLabel ?? label}
      label={label}
      inputMode="text"
      autoCapitalize="none"
      autoCorrect={false}
      {...rest}
    />
  );
};
